import { AppFormSection } from '../ui/AppFormSection';
import { useLocalization } from '../lib/hooks/useLocalization';
import { Product } from '../processes/CMS/processes/management/pages/FindersAndProductsPage/lib/Product';

export function ProductNameFormItem(props) {
  const { label } = useLocalization().translations.unique.formItems.productName;
  const { formItemProps, textFieldProps } = props;

  return (
    <AppFormSection
      formItemProps={{
        name: Product.NAME,
        rules: [{ required: true }, { whitespace: true }],
        ...formItemProps,
      }}
      textFieldProps={{
        label,
        ...textFieldProps,
      }}
    />
  );
}
